import {safeWebUrlOf} from '@Utils/url.util';
import {openEditorInNewTab} from '@Components/ai-chat-window/lib/open-editor-tab.library';
import {EntityCardEntityType} from '@Components/ai-chat-window/components/entity-card/entity-card.types';
import type {EntityCardAction} from './entity-card-action.types';

interface DesignEntityPayload {
  editorUrl: string;
}

/** Clicking a design opens it in the editor in a new tab; an editor link that is not a web link opens nothing. */
export const designEntityCardAction: EntityCardAction<DesignEntityPayload> = {
  entityType: EntityCardEntityType.DESIGN,
  parsePayload: (raw): DesignEntityPayload => ({editorUrl: safeWebUrlOf(raw.editorUrl)}),
  onClick: (payload): void => {
    if (!payload.editorUrl) {
      return;
    }

    openEditorInNewTab(payload.editorUrl);
  },
};
